<template>
  <Transition name="fade">
    <div
      v-if="isVisible"
      data-cy="chat-toast"
      class="w-64 rounded-lg bg-white px-4 py-3 text-headline shadow-lg"
    >
      <div class="flex items-start">
        <div class="flex-1">
          <p class="text-sm">{{ message || t("chat.greeting") }}</p>
        </div>
        <button
          data-cy="toast-close-button"
          class="ml-2 text-gray-400 hover:text-gray-600"
          :aria-label="t('CHAT.CLOSE')"
          @click="close"
        >
          <icon-x :width="18" :height="18" />
        </button>
      </div>
      <!-- Triangle pointer at bottom -->
      <div class="absolute right-6 -bottom-2 h-4 w-4 rotate-45 transform bg-white"></div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import IconX from "@/components/icons/IconX.vue";

const { t } = useI18n();

const {
  message = "",
  autoHideAfter = 0,
  showAfter = 0,
} = defineProps<{
  message?: string;
  autoHideAfter?: number;
  showAfter?: number;
}>();

const emit = defineEmits<{ close: [] }>();

const isVisible = ref(false);

const close = () => {
  isVisible.value = false;
  emit("close");
};

onMounted(async () => {
  // Show the toast after the specified delay
  setTimeout(() => {
    isVisible.value = true;
    // Auto-hide if specified
    if (autoHideAfter) {
      setTimeout(() => {
        isVisible.value = false;
      }, autoHideAfter);
    }
  }, showAfter);
});
</script>

<style scoped>
@reference "@/tailwind.css";

.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.3s,
    transform 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
